import { useEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export default function useElementResizeObserver({
    isEnable = true,
    callback,
    unmountCallback
} = {}) {
    const [ref, setRef] = useState(null);
    useEffect(() => {
        if (isEnable && ref) {
            // Check to see if the native version is available and switch between this and the polyfill to improve performance on browsers with native support.
            // Use dynamic imports to only load the file when the polyfill is required.
            (async () => {
                if ('ResizeObserver' in window === false) {
                    const module = await import('@juggle/resize-observer');
                    window.ResizeObserver = module.ResizeObserver;
                }
                // Uses native or polyfill, depending on browser support.
                const ro = new ResizeObserver(entries => {
                    for (const entry of entries) {
                        if (entry.target === ref) {
                            callback(ref);
                        }
                    }
                });
                ro.observe(ref);
                return () => {
                    ro.unobserve(ref);
                    if (typeof unmountCallback === 'function') {
                        unmountCallback();
                    }
                };
            })();
        }
    }, [isEnable, ref, callback, unmountCallback]);
    return [ref, setRef];
}
